import {
    useCallback,
    useState,
    useMemo,
    type FC,
    useId
} from "react";
import {
    View
} from "react-native";
import type ITraceCollapsibleProps from "./type";
import stylesheet from "./stylesheet";
import type {
    TraceCollapsibleContextType
} from "../../type";
import {
    TraceCollapsibleContext
} from "../../context";

const TraceCollapsible: FC<ITraceCollapsibleProps> = ({
    isDefaultOpen = false,
    isOpen: isOpenProp,
    onOpenChange,
    children,
    style,
    ...props
}) => {
    const baseID = useId().replace(/[^a-zA-Z0-9]/g, "");

    const [
        isOpenState,
        setIsOpenState
    ] = useState(isDefaultOpen);

    const isControlled = isOpenProp !== undefined;

    const isOpen = isControlled ? isOpenProp : isOpenState;

    const handleToggle = useCallback(() => {
        const nextIsOpen = !isOpen;

        if(!isControlled) {
            setIsOpenState(nextIsOpen);
        }

        onOpenChange?.(nextIsOpen);
    }, [
        onOpenChange,
        isControlled,
        isOpen
    ]);

    const context: TraceCollapsibleContextType = useMemo(() => ({
        contentID: `traceContent${baseID}`,
        triggerID: `traceTrigger${baseID}`,
        handleToggle,
        isOpen
    }), [
        handleToggle,
        baseID,
        isOpen
    ]);

    return <TraceCollapsibleContext.Provider
        value={context}
    >
        <View
            {...props}
            style={[
                style,
                stylesheet.container
            ]}
        >
            {children}
        </View>
    </TraceCollapsibleContext.Provider>;
};
export default TraceCollapsible;
